import React from 'react';
import { MenuList, MenuItem, FormControlLabel, Checkbox } from '@mui/material';
import { useDispatch } from 'react-redux';
import { addToArrIfNotExistOrRemove } from '../../utils/helpers';

const MenuListMultiSelect = ({ store, customFiltersList, actionToDispatch }) => {
  const dispatch = useDispatch()

  const handleCheckboxClick = (singleFacet) => {
    const newArray = addToArrIfNotExistOrRemove(store.activeFilters || [], 'id', singleFacet)
    dispatch(actionToDispatch({ queries: newArray }))
  };

  const filtersList = customFiltersList || store?.filterList

  return (
        <MenuList>
            {filtersList?.map((singleFacet) => (
                <MenuItem key={singleFacet?.id} sx={styles.option}>
                    <FormControlLabel
                        sx={styles.customCheckStyle}
                        control={
                            <Checkbox
                                checked={
                                  store.activeFilters?.some((item) => item?.id === singleFacet?.id)
                                }
                                onClick={() => handleCheckboxClick(singleFacet)}
                                name={singleFacet.name}
                                color='primary'
                                id={singleFacet.id}
                            />
                        }
                        label={singleFacet.name}
                    />
                </MenuItem>
            ))}
        </MenuList>
  );
};

const styles = {
  option: {
    color: '#000000',
    textTransform: 'capitalize',
    minWidth: { xs: 'max-content', sm: '130px' },
    fontSize: { xs: '10px', sm: '16px' },
    margin: { xs: '0', sm: '5px 0' },
    padding: '0px',
    '& .MuiSvgIcon-root': {
      marginRight: { xs: '5px', sm: '7px' },
      width: { xs: '25px', sm: 'unset' },
      height: { xs: '25px', sm: 'unset' },
    },
    '& .MuiTypography-root': {
      fontSize: { xs: '11px', sm: '16px' },
    },
  },
  customCheckStyle: {
    width: '100%',
    padding: '0 5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
}

export default MenuListMultiSelect;
